import { createFileRoute } from "@tanstack/react-router";
import { InboxPage } from "@/features/inbox/inbox-page";
import { inboxSearchSchema } from "@/features/inbox/model";

export const Route = createFileRoute("/_app/inbox")({
  validateSearch: inboxSearchSchema,
  head: () => ({ meta: [{ title: "Inbox · Malfak" }] }),
  component: InboxRoute,
});

function InboxRoute() {
  const search = Route.useSearch();
  return <InboxPage search={search} />;
}
